import { defineStore } from 'pinia'
import { ref } from 'vue'
import { apiFetch } from '@/auth/apiFetch'

/**
 * Thin compatibility layer over apiFetch — preserved so the existing 30+
 * stores/pages that call suiteStore.suiteFetch don't have to be refactored.
 * All real auth/recovery logic lives in apiFetch + recoverSession + gotoLogin.
 */
export const useSuiteStore = defineStore('suite', () => {
  const isSuiteAvailable = ref<boolean | null>(null)

  const checkSuiteUrl = async (): Promise<boolean> => {
    const suiteUrl = import.meta.env.VITE_SUITE_URL
    isSuiteAvailable.value = !(!suiteUrl || suiteUrl === '')
    return true
  }

  const suiteFetch = async (path: string, options: RequestInit = {}): Promise<Response | false> => {
    if (isSuiteAvailable.value === false) {
      console.error('SUITE is not available.')
      return false
    }
    try {
      return await apiFetch(path, options)
    } catch (err) {
      console.error('suiteFetch network error', err)
      return false
    }
  }

  return {
    isSuiteAvailable,
    checkSuiteUrl,
    suiteFetch,
  }
})
